// 数据看板-用户管理
<template>
  <div class="DkbOrganizeManage">
    <div class="operateArea">
      <div class="searchArea">
        <el-input class="text" v-model="userData.paging.user_name" placeholder="请输入姓名" clearable></el-input>
        <el-input class="text" v-model="userData.paging.user_account" placeholder="请输入账号" clearable></el-input>
        <el-input class="text" v-model="userData.paging.phone_no" placeholder="请输入手机号" clearable></el-input>
        <span class="btn-search" @click="getUserList('search')">搜&nbsp;索</span>
      </div>
      <div class="btnArea">
        <span class="btn" @click="operateDialogInfo('addUser')">添加用户</span>
        <span class="btn" @click="goMore">更多设置</span>
      </div>
    </div>
    <div class="listBox" v-loading="userData.loading"
      element-loading-background="rgba(240, 243, 248, 0.7)" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <NoData v-if="userData.list.length === 0" />
      <div class="listWrapper" v-else>
        <div
          class="list" 
          v-for="(item, index) in userData.list" :key="index">
          <div class="one">
            <div class="num">{{(index+1)}}</div>
            <div class="name one-line-overhidden" :title="item.user_name">{{item.user_name}}</div>
          </div>
          <div class="two">
            <p class="text"><span class="blue">电话：</span>{{item.phone_no}}</p>
            <p class="text"><span class="blue">部门：</span>{{item.department_name}}</p>
          </div>
          <span class="btn-edit" @click="operateDialogInfo('alterUser', item)"></span>
        </div>
      </div>
      <el-pagination
        class="dkbPagination"
        @current-change="userPageChange"
        :current-page.sync="userData.paging.page"
        layout="prev, pager, next, jumper"
        :page-count="userData.pageCount"
        v-if="userData.pageCount > 1">
      </el-pagination>
    </div>
    <el-dialog
      class="DkbInnerDialog"
      :title="innerTitle"
      :visible.sync="innerVisible"
      append-to-body>
          <!-- 添加/修改用户 -->
          <div
            class="innerForm"
            v-if="dialogData.type === 'addUser' || dialogData.type === 'alterUser'">
              <el-form
              label-width="90px"
              :model="dialogData.info">
              <el-form-item label="姓名:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.user_name"></el-input>
                </div>
              </el-form-item>
              <el-input style="position:fixed;bottom:-9999px"></el-input>
              <el-input type="password" style="position:fixed;bottom:-9999px"></el-input>
              <el-form-item label="账号:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.user_account" placeholder="字母或者数字的组合，限制6~15位" autocomplete="new-user"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="密码:">
                <div class="inputBox" v-if="dialogData.info.isAlter">
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass" placeholder="[要更改保存的密码，请单击这里]"></el-input>
                </div>
                <div class="inputBox" v-else>
                  <el-input class="inputDeposit" v-model="dialogData.info.password" type="password" show-password autocomplete="new-pass"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="手机号码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.phone_no" autocomplete="new-phone"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="邮箱:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.email"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="部门:">
                <div class="inputBox">
                  <el-select
                    class="inputBox"
                    v-model="dialogData.info.department_id"
                    placeholder="请选择上级部门">
                    <el-option
                      v-for="item in departmenList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="权限:">
                <div class="inputBox">
                  <el-select class="inputBox" v-model="dialogData.info.role_id" multiple placeholder="请选择">
                    <el-option
                      v-for="(item, index) in roleList"
                      :key="index"
                      :label="item.role_name"
                      :value="item.role_id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <span class="btn btn-confirm" @click="updateUser()">确 认</span>
            </div>
          </div>

    </el-dialog>
    <!-- <el-button type="primary" @click="innerVisible = true">打开内层 Dialog</el-button> -->
  </div>
</template>

<script>
  import NoData from '@/components/DkbPage/DialogPage/NoData'
  import { showToast, updataBreadCrumb, deepCopy } from "../../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../../static/js/api.js"
  let vm

  export default {
    name: 'DkbOrganizeManage',
    components: {
      NoData
    },
    data () {
      return {
        innerTitle: '',
        innerVisible: false,
        dialogData:{ // 对话框数据
          type: '',
          info: {}

          // type: 'addUser',
          // info: {
          //   user_id: '',
          //   user_name: '',
          //   phone_no: '',
          //   user_account:'',
          //   password:'',
          //   email: '',
          //   department_id: '0',
          //   role_id: []
          // }
        },
        userData: {  // 用户数据
          // 分页数据  page为当前页，perPage为每页数量，phone_no账号搜索，user_name用户姓名搜索
          paging: {
            page: 1,
            perPage: 15,
            department_id: '0',
            phone_no: '',
            user_account: '',//账号
            user_name: ''
          },
          // 用户列表
          list: [],
          loading: false,
        },
        departmenList: [], // 部门列表
        roleList: [],      //权限列表


        input: ''
      }
    },
    created () {
      vm = this
      vm.getUserList()
    },
    mounted() {
    },
    computed: {
    },
    methods: {
      // 去企业后台更多设置
      goMore () {
        let navBarActive = [{function_tab: 'CUserManege', function_name: '用户中心'}, {function_tab: 'COrganizeManage', function_name: '组织管理'}]
        // 更新面包屑内容
        updataBreadCrumb(2, navBarActive)
        vm.$router.push({path: '/COrganizeManage'})
      },
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        // console.log('count', this.count)
        // 重置调用角色用户列表API次数
        // this.count = 0
        // 用户信息
        let userInfo
        if (type === 'addUser') {
          userInfo = {
            user_id: '',
            user_name: '',
            phone_no: '',
            user_account:'',
            password:'',
            email: '',
            department_id: '0',
            role_id: []
          }
        }
        if(type == 'alterUser'){
          info.password=''
          info.isAlter = '1'
        }
        vm.getAllDepartment('0')
        vm.getRoleList()

        vm.innerVisible = true
        vm.innerTitle = type === 'addUser' ? '添加用户' :
                        type === 'alterUser' ? '修改用户' : ''
        vm.dialogData = {
          type: type,
          info: type === 'addUser' ? userInfo : deepCopy(info)
        }

        console.log('vm', vm.dialogData)
      },
      // 获取用户列表
      getUserList: async function (value, update) {
        let vm = this
        let data = vm.userData.paging
        if (value) {
          // 为搜索
          if (value === 'search') {
            data.page = 1
            if (data.phone_no === '' && data.user_name === '' && data.user_account === '') {
              showToast('请输入搜索内容！')
              return
            }
          } else {
            // 是id
            data.department_id = value
            vm.userData.selected = update ? vm.userData.selected : value
          }
        }

        vm.userData.loading = true
        let res = await userApi.getUserList(data)
        vm.userData.loading = false
        if (res.meta.code === 200) {
          vm.userData.list = [...res.data.list]
          vm.userData.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 用户列表当前页值改变，获取新用户列表
      userPageChange(val) {
        this.getUserList()
      },
      // 获取所有未分组部门列表
      getAllDepartment: async function (id) {
        let vm = this
        let data = { id }

        let res = await userApi.getAllDepartment(data)
        if (res.meta.code === 200) {
          vm.departmenList = [...res.data]
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取角色列表
      getRoleList: async function () {
        let vm = this
        let data = {
          page: 1,
          perPage: 1000000
        }

        let res = await userApi.getRoleList(data)
        if (res.meta.code === 200) {
          vm.roleList = [...res.data.list]
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新（添加/修改）用户
      updateUser: async function () {
        let vm = this
        let data = {
          user_id: vm.dialogData.info.user_id,
          user_name: vm.dialogData.info.user_name,
          user_account: vm.dialogData.info.user_account,
          phone_no: vm.dialogData.info.phone_no,
          email: vm.dialogData.info.email,
          department_id: vm.dialogData.info.department_id,
          role_id: vm.dialogData.info.role_id
        }
        if(vm.dialogData.info.isAlter){
          if(vm.dialogData.info.password){
            data.password= vm.dialogData.info.password
          }
        }else{
          data.password= vm.dialogData.info.password
        }

        // 判断
        if (data.user_name === '') {
          showToast('姓名不能为空！')
          return
        }
        let reUser = new RegExp(/^[0-9a-zA-Z]{6,15}$/)
        if (data.user_account === '') {
          showToast('账号不能为空！')
          return
        } else if (!reUser.test(data.user_account)) {
          showToast('请填写6-15位字母和数字组合的账号')
          return
        }
        let rePass = new RegExp(/^[\w]{6,20}$/)
        if (data.password === '') {
          showToast('密码不能为空！')
          return
        } else if (!rePass.test(data.password)) {
          showToast('请填写6-20位字母、数字和下划线组合的密码')
          return
        }
        if (data.phone_no === '') {
          showToast('手机号码不能为空！')
          return
        } else if (data.phone_no.length !== 11) {
          showToast('请填写正确的手机号！')
          return
        }
        if (data.email === '') {
          showToast('邮箱不能为空！')
          return
        }
        // if (data.role_id.length === 0) {
        //   showToast('请选择权限！')
        //   return
        // }

        let res = await userApi.updateUser(data)
        if (res.meta.code === 200) {
          showToast(vm.innerTitle + '成功')
          vm.innerVisible = false
          vm.getUserList()
        } else {
          showToast(res.meta.message)
        }
      },
    },
    watch: {
      // 监听tab用户的搜索字段user_name为空，获取新的用户列表
      'userData.paging.user_name' : function (newVal) {
        if (newVal === '') {
          this.getUserList()
        }
      },
      // 监听tab用户的搜索字段user_account为空，获取新的用户列表
      'userData.paging.user_account' : function (newVal) {
        if (newVal === '') {
          this.getUserList()
        }
      },
      // 监听tab用户的搜索字段phone_no为空，获取新的用户列表
      'userData.paging.phone_no' : function (newVal) {
        if (newVal === '') {
          this.getUserList()
        }
      },
    }
  }
  
</script>

<style lang="scss">
.DkbOrganizeManage {
  width: 10.31rem;
  margin: 0 auto;
  .operateArea {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .searchArea {
      flex-shrink: 0;
      display: flex;
      .text {
        width: 1.95rem;
        .el-input__inner {
          height: 0.36rem;
          line-height: 0.36rem;
          color: #a6aeb8;
          border: none;
          border-radius: 0.04rem;
          background-color: #34526e;
        }
        .el-input__inner::placeholder{
          color:#a6aeb8;
        }
      }
      .text+.text {
        margin-left: 0.15rem;
      }
      .btn-search {
        margin-left: 0.25rem;
      }
    }
    .btnArea {
      display: flex;
      .btn {
        width: 1.17rem;
        height: 0.37rem;
        background: url(/static/images/dkb/dialog/btn_bg.png) center no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 0.37rem;
        font-size: 0.14rem;
        color: #ffffff;
      }
    }
  }
  .listBox {
    width: 100%;
    height: 4.9rem;
    margin-top: 0.37rem;
    padding: 0.36rem 0.4rem 0;
    border: 0.02rem solid #7ca8cf;
    box-sizing: border-box;
    box-shadow: 0 0 0.34rem rgba(0, 0, 0, 0.2), 0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
    .listWrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .list {
        width: 1.64rem;
        height: 1.01rem;
        margin-right: 0.31rem;
        margin-bottom: 0.22rem;
        padding: 0.13rem 0 0 0.11rem;
        box-sizing: border-box;
        border-radius: 0.05rem;
        border: 0.02rem solid #7ca8cf;
        box-shadow: 0 0 0.34rem rgba(0, 0, 0, 0.2), 0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
        display: flex;
        flex-direction: column;
        position: relative;
        .one {
          display: flex;
          .num {
            flex-shrink: 0;
            width: 0.37rem;
            height: 0.22rem;
            line-height: 0.22rem;
            font-size: 0.12rem;
            color: #082e50;
            background-color: #ffffff;
            border-radius: 0.04rem;
            text-align: center;
          }
          .name {
            max-width: 0.7rem;
            font-size: 0.14rem;
            margin-left: 0.1rem;
            color: #ffffff;
          }
        }
        .two {
          margin-top: 0.1rem;
          font-size: 0.12rem;
          line-height: 0.18rem;
          color: #cccccc;
          .blue {
            color: #7ca8cf;
          }
        }
        .btn-edit {
          display: block;
          width: 0.17rem;
          height: 0.17rem;
          background: url(/static/images/dkb/dialog/btn_edit.png) center no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: 0.1rem;
          top: 0.14rem;
        }
      }
      .list:nth-child(5n) {
        margin-right: 0;
      }
    }
    .dkbPagination {
      margin: 0.12rem 0 0.24rem;
    }
  }
  
.innerForm {
  padding-top: 0.16rem;
  color: #ffffff;
  .el-form {
    .el-form-item {
      .el-form-item__label {
        color: #ffffff;
        font-size: 0.16rem;
      }
      .inputBox {
        width: 4rem;
        height: 0.4rem;
        input {
          border: none;
          background-color: #2d5391;
          color:#ffffff;
        }
        input::placeholder{
          color:#a6aeb8;
        }
      }
    }
  }
  .dialog-footer {
    margin-top: 0.4rem;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/DialogPage/UserManage/UserManage.vue